import FinancialAnalysisComponent
  from '@app/features/analysis-refactor/pages/analysis-configuration/pages/financial-analysis/financial-analysis.component';
import {Route} from '@angular/router';

export const financialAnalysisRoute : Route[] = [
  {
    path: '',
    component: FinancialAnalysisComponent,
    children: [
      {
        path: '',
        redirectTo: '/financial-overview',
        pathMatch: 'full'
      },
      {
        path: 'financial-overview',
        pathMatch: 'full',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/financial-analysis/financial-overview/components/financial-overview-graph/financial-overview-graph.component')
      },
      {
        path: 'cost-revenue',
        pathMatch: 'full',
        loadComponent: () => import('@app/features/analysis-refactor/pages/analysis-configuration/pages/financial-analysis/cost-revenue/cost-revenue.component')
      },
    ]
  }
];
